const replaceHalfYear = (target: string, match: string, value: string) => {
  let newString = target
  if (newString.includes(match)) {
    newString = newString.replace(match, value)
  }

  return newString
}

export const getPeriodTitle = (quarters: number[], fYear: number) => {
  let joined = quarters.map((quarter) => `Q${quarter}`).join('+')
  const yearTwoDigits = fYear.toString().slice(-2)

  const h1 = 'Q1+Q2'
  joined = replaceHalfYear(joined, h1, 'H1')
  const h2 = 'Q3+Q4'
  joined = replaceHalfYear(joined, h2, 'H2')

  if (joined === 'H1+H2') {
    return `FY${yearTwoDigits}`
  }

  return `${joined}'${yearTwoDigits}`
}
